import moment from 'moment-jalaali';

// Initialize moment-jalaali
moment.loadPersian({ usePersianDigits: false });

export function isISODateString(value) {
  return typeof value === 'string' &&
    /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}.*)?$/.test(value);
}

export function formatJalaliDate(value) {
  if (!value) return '';
  
  try {
    const str = String(value).trim();
    
    // Handle different date formats
    let m;
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      // Standard ISO date format (YYYY-MM-DD)
      m = moment(str, 'YYYY-MM-DD', true);
    } else if (/^\d{4}-\d{2}-\d{2}T/.test(str)) {
      // ISO datetime format (with timezone)
      // moment-jalaali can parse ISO strings directly
      m = moment(str);
    } else if (/^\d{4}\/\d{2}\/\d{2}$/.test(str)) {
      // Date with slashes (YYYY/MM/DD)
      m = moment(str, 'YYYY/MM/DD', true);
    } else {
      // Try general parsing
      m = moment(str);
    }
    
    if (!m.isValid()) {
      console.warn('Invalid date:', str);
      return '';
    }
    
    const result = m.format('jYYYY/jMM/jDD');
    return result;
  } catch (error) {
    console.warn('formatJalaliDate error:', error, 'for value:', value);
    return '';
  }
}

export function formatJalaliDateTime(value) {
  if (!value) return '';
  
  try {
    const str = String(value).trim();
    
    // Handle different date formats
    let m;
    if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
      // Standard ISO date format (YYYY-MM-DD)
      m = moment(str, 'YYYY-MM-DD', true);
    } else if (/^\d{4}-\d{2}-\d{2}T/.test(str)) {
      // ISO datetime format (with timezone)
      // moment-jalaali can parse ISO strings directly
      m = moment(str);
    } else if (/^\d{4}\/\d{2}\/\d{2}$/.test(str)) {
      // Date with slashes (YYYY/MM/DD)
      m = moment(str, 'YYYY/MM/DD', true);
    } else {
      // Try general parsing
      m = moment(str);
    }
    
    if (!m.isValid()) {
      console.warn('Invalid date:', str);
      return '';
    }
    
    // Format: jYYYY/jMM/jDD - HH:mm
    const result = m.format('jYYYY/jMM/jDD - HH:mm');
    return result;
  } catch (error) {
    console.warn('formatJalaliDateTime error:', error, 'for value:', value);
    return '';
  }
}
